import type { GetAppIntegrationUsersParams, GetSoftwareLicenseSubGroupsParams, GetSoftwareUserGroupsParams } from './type';
export const appIntegrationKey = {
  all: (id: string) => ['app-integrations', id] as const,
  rule: (id: string) => [...appIntegrationKey.all(id), 'rules'] as const,
  setting: (id: string) => [...appIntegrationKey.all(id), 'settings'] as const,
  // TODO: integratableApp(appのmarketplaceから連携可能なアプリ)はこのオブジェクトでの管理は不適切なので移動する
  integratableApp: (appId: string) => ['integratable-app', {
    appId
  }] as const,
  users: (id: string) => [...appIntegrationKey.all(id), 'users'] as const,
  usersSearch: (id: string, search: GetAppIntegrationUsersParams) => [...appIntegrationKey.users(id), 'search', {
    search
  }] as const,
  // MDM configuration
  mdmConfiguration: (id: string) => [...appIntegrationKey.all(id), 'mdm-configuration'] as const,
  // Software data
  software: (id: string) => [...appIntegrationKey.all(id), 'software'] as const,
  // User groups
  userGroups: (softwareId: string) => ['software', softwareId, 'user-groups'] as const,
  userGroupsSearch: (softwareId: string, search: GetSoftwareUserGroupsParams) => [...appIntegrationKey.userGroups(softwareId), {
    search
  }] as const,
  // License sub groups
  licenseSubGroups: (softwareId: string) => ['software', softwareId, 'license-subgroups'] as const,
  licenseSubGroupsSearch: (softwareId: string, search: GetSoftwareLicenseSubGroupsParams) => [...appIntegrationKey.licenseSubGroups(softwareId), {
    search
  }] as const
} as const;